<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :footer="null"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        class="j-table-force-nowrap">

        <span slot="action" slot-scope="text, record">
          <a v-if="record.isPublish==='1'" @click="handleView(record)">查看<a-divider type="vertical"/></a>
          <a v-if="record.isPublish!=='1' && record.noticeNature==='2' " @click="handleEditSupply(record)">编辑<a-divider type="vertical"/></a>
          <a v-if="record.isPublish!=='1' && record.noticeNature==='2'" @click="handlePublish(record)">发布</a>
        </span>

      </a-table>
    </a-spin>
    <!-- 表单区域 -->
    <land-transfer-notice-modal  @loadData="loadData" ref="modalForm" @ok="modalFormOk"></land-transfer-notice-modal>
    <mining-right-transfer-notice-modal  @loadData="loadData" ref="mineModalForm" @ok="modalFormOk"></mining-right-transfer-notice-modal>
  </a-modal>
</template>

<script>

import { FzisListMixin } from '@/mixins/FzisListMixin'
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";
import LandTransferNoticeModal from "@views/earthmine/modules/LandTransferNoticeModal.vue";
import {postAction} from "@api/manage";
import MiningRightTransferNoticeModal from "@views/earthmine/modules/MiningRightTransferNoticeModal.vue";


export default {
  components: {MiningRightTransferNoticeModal, LandTransferNoticeModal},
  mixins:[FzisListMixin],
  name: "TransferNoticeHisModal",
  data () {
    return {
      tokenHeader: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      title:"操作",
      visible: false,
      disableSubmit:false,
      modal: {},
      disableMixinCreated:true,
      confirmLoading: false,
      form: this.$form.createForm(this),
      id:"",
      type:"",
      fileList:[],
      queryParam:{

      },
      url: {
        list: "/ebid-ce/emTransferNotice/his/page",
      },
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:function (t,r,index) {
            return parseInt(index)+1;
          }
        },{
          title: '公告类型',
          align:"center",
          dataIndex: 'noticeNature',
          width: 100,
          customRender: function(t, r, index) {
            if(t==="1")
            {
              return "出让公告"
            }else
            {
              return "补充公告"
            }
          }
        },
        {
          title: '公告编号',
          align:"center",
          dataIndex: 'noticeCode',
          width: 250,
        },
        {
          title: '公告名称',
          align:"center",
          dataIndex: 'noticeName',
          width: 300,
        },
        {
          title: '发布时间',
          align:"center",
          dataIndex: 'publishTime',
          width: 150,
        },
        {
          title: '操作',
          dataIndex: 'action',
          align:"center",
          scopedSlots: { customRender: 'action' },
        }
      ],
    }
  },
  computed: {
    uploadAction() {
      return window._CONFIG['domianURL'] + '/ebid-ce/file/onlyUpload'
    },
  },
  created () {
  },
  methods: {
    handleOk(){
      this.handleCancel();

    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleCancel () {
      this.visible = false;
    },
    handleView: function (record) {
      if(this.type==="1")
      {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = "查看";
        this.$refs.modalForm.disableSubmit = true;
      }else
      {
        this.$refs.mineModalForm.edit(record);
        this.$refs.mineModalForm.title = "查看";
        this.$refs.mineModalForm.disableSubmit = true;
      }


    },
    handleEditSupply: function (record) {
      if(this.type==="1")
      {
        this.$refs.modalForm.isSupply = true;
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = "编辑";
        this.$refs.modalForm.disableSubmit = false;
      }else
      {
        this.$refs.mineModalForm.isSupply = true;
        this.$refs.mineModalForm.edit(record);
        this.$refs.mineModalForm.title = "编辑";
        this.$refs.mineModalForm.disableSubmit = false;
      }
    },

    listView(record,type)
    {
      this.type=type;
      if(type==="1")
      {
        this.queryParam.bulletinType="1";
        this.queryParam.linkId=record.id;
      }
      else if(type==="2")
      {
        this.queryParam.bulletinType="2";
        this.queryParam.linkId=record.id;
      }
      console.log("queryParam",this.queryParam)
      this.loadData();

    },
    handlePublish(record)
    {
      const that = this
      that.$confirm({
        title: '提示',
        content: '是否确认发布项目?',
        onOk() {
          that.loading = true
          postAction('/ebid-ce/emTransferNotice/setPublish/'+record.id).then((res) => {
            if (res.success) {
              that.$message.success('发布成功')
              that.loadData();
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.loading = false
          })
        },
        onCancel() {
        }
      })
    },
  }
}
</script>

<style scoped>
.labelTop{
  margin-top: 10px;
  text-align: right;
  color:#262626;
}
</style>